import { useTranslation } from 'react-i18next';
import { useEffect, useState, useRef } from 'react';
import { changeLanguageWithReload } from '../i18n';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const changeLanguage = (lng) => {
    setIsOpen(false);
    changeLanguageWithReload(lng);
  };

  useEffect(() => {
    // Set initial direction based on current language
    const currentLang = i18n.language || 'en';
    document.documentElement.dir = currentLang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = currentLang;
  }, [i18n.language]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const languages = [
    { code: 'en', name: 'English', flag: '' },
    { code: 'ar', name: 'العربية', flag: '' },
    { code: 'fr', name: 'Français', flag: '' }
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  return (
    <div className="language-switcher" ref={dropdownRef}>
      <button 
        className="language-switcher-toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Change language"
      >
        <i className="fa-solid fa-globe"></i>
      </button>
      
      {isOpen && (
        <div className="language-dropdown">
          {languages.map((lang) => (
            <button
              key={lang.code}
              className={`language-option ${i18n.language === lang.code ? 'active' : ''}`}
              onClick={() => changeLanguage(lang.code)}
            >
              <span className="language-flag">{lang.flag}</span>
              <span className="language-name">{lang.name}</span>
              {i18n.language === lang.code && (
                <i className="fa-solid fa-check"></i>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;

